var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.121 9.879 9.878 14.12M10.333 7 12 5.333a4.714 4.714 0 0 1 6.666 0v0a4.714 4.714 0 0 1 0 6.667L17 13.667M13.667 17 12 18.667a4.714 4.714 0 0 1-6.666 0v0a4.714 4.714 0 0 1 0-6.667L7 10.333",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export default SvgLink;